import { css } from '@emotion/css';

export const checkoutGameStyles = css`
    display: flex;
    justify-content: center;
    align-items: center;
    h5 {
        margin-bottom: 0px;
    }
    margin-bottom: 0.5em;
`;